import { DateFormatEnum, formatStringToDate, isValidDate } from "@core/utils";
import { AbstractOptionalValidation } from "./abstractOptionalValidation";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export class DateNotInRangeValidation extends AbstractOptionalValidation {
  key = "isDateNotInRangeValidation";

  constructor(
    isRequired: boolean,
    private readonly minYear: number,
    private readonly maxYear: number,
    customErrorMessage?: CustomErrorMessage
  ) {
    super(isRequired, customErrorMessage);
  }

  validateValue(value: string): boolean {
    if (isValidDate(value as unknown as string, DateFormatEnum.Date)) {
      const date = formatStringToDate(value as unknown as string, DateFormatEnum.Date);

      return date.getFullYear() >= this.minYear && date.getFullYear() <= this.maxYear;
    }

    return false;
  }
}
